import {
  ChangeDetectorRef,
  Component,
  Input,
  output,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

import type { IconName } from '@core/user-interface-legacy';
import { CheckboxComponent, HeadingComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-work-model-item',
  imports: [IconComponent, HeadingComponent, CheckboxComponent],
  templateUrl: './work-model-item.component.html',
  styleUrls: ['./work-model-item.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(mouseenter)': 'onHover(true)',
    '(mouseleave)': 'onHover(false)',
    '[class.selected]': 'isSelected',
    '[class.read-only]': 'readOnly()',
  },
})
export class WorkModelItemComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  public readonly title = input<string>(undefined!);
  public readonly description = input<string>(undefined!);
  public readonly readOnly = input<boolean>(undefined!);
  public readonly icon = input<IconName>(undefined!);
  @Input() public isSelected: boolean;

  public select = output<void>();

  public isMouseover: boolean;

  public onHover(mouseover: boolean) {
    this.isMouseover = mouseover;
    this.cdRef.detectChanges();
  }
}
